export default __webpack_public_path__ + "static/media/LandUseCharge.b6dd9053.png";